import { Link, useLocation } from 'react-router-dom';
import { BarChart3, UtensilsCrossed, Dumbbell, User } from 'lucide-react';

export function BottomNav() {
    const location = useLocation();

    const navItems = [
        { path: '/', icon: BarChart3, label: 'Dashboard' },
        { path: '/dieta', icon: UtensilsCrossed, label: 'Dieta' },
        { path: '/treino', icon: Dumbbell, label: 'Treino' },
        { path: '/perfil', icon: User, label: 'Perfil' },
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 safe-area-pb">
            <div className="flex justify-around items-center h-16 max-w-2xl mx-auto">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    const Icon = item.icon;

                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors ${isActive
                                ? 'text-primary'
                                : 'text-muted-foreground hover:text-foreground'
                                }`}
                        >
                            <Icon className={`h-5 w-5 ${isActive ? 'fill-current' : ''}`} />
                            <span className="text-xs font-medium">{item.label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
}
